module.exports = __webpack_public_path__ + "img/sankaku_40_red.03396f1e.png";